import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import React, { useEffect, useState } from 'react'
import TextField from '@mui/material/TextField';
import { useNavigate, useParams } from 'react-router-dom';
import FormPageHeader from '../utilities/FormPageHeader';
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import { checkString } from '../utilities/FormValidation';

const PriceGroupForm = () => {
    const [tabValue, setTabValue] = useState(0);
    const { id } = useParams()
    const navigate = useNavigate()
    const [error, setError] = useState("")
    const [isNavigate, setIsNavigate] = useState(false)
    const [validError, setValidError] = useState({});
    const [checksubmit, setCheckSubmit] = useState(false);
    const [description, setDescription] = useState("")
    const [pgName, setPgName] = useState("")
    const [snackState, setSnackState] = useState(false);
    const [successMsg, setSuccessMsg] = useState();
    const [editdata, setEditData] = useState();
    const [hideDelete, setHideDelete] = useState(true);
    const [saveDisable, setSaveDisable] = useState(true);
    const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.priceGroup}`;

    useEffect(() => {
        if (id) {
            editPriceGroupData();
            setHideDelete(false)
        }
    }, [])

    const editPriceGroupData = async () => {
        try {
            const result = await OAuthService.getEditData(url, id);
            const priceGroupData = result?.data
            // const url1 = process.env.REACT_APP_RESOURCE_API_KEY_URL
            // const url2 = priceGroupData._links.priceGroup.href.split("/api")[1]
            // setPgName(`${url1}api${url2}`)
            setPgName(priceGroupData ?.pgId)

            // setPgName(priceGroupData._links.priceGroup.href.split('/').pop())
            setDescription(priceGroupData.description)
            setEditData(priceGroupData)
        } catch (error) {
            console.log('error', error);
            setError(error?.response?.data?.errorMessage || error.message)
        }
    }

    const handleDelete = async () => {
        try {
            if (id) {
                await OAuthService.deleteData(url, id);
                setSuccessMsg("Data deleted Successfully")
                setSnackState(true);
            }

        } catch (error) {
            setError(error?.response?.data?.errorMessage || error.message);
            return;
        }
        setTimeout(() => { navigate('/pricegroups') }, 800);
    }

    const handleSubmit = async () => {
        setCheckSubmit(true);
        let model = {
            description: description,
            pgId: pgName
        }

        try {
            if (id) {
                if (description && !validError.description) {
                    await OAuthService.updateData(url, id, model);
                    setSuccessMsg("Data Updated Successfully")
                    setSnackState(true);
                    setTimeout(() => { navigate('/pricegroups'); }, 800)
                }
            } else {
                if (description && !validError.description) {
                    await OAuthService.addData(url, model);
                    setSuccessMsg("Data saved Successfully")
                    setSnackState(true);
                    setTimeout(() => { navigate('/pricegroups'); }, 800)
                }
            }

        } catch (error) {
            setError(error?.response?.data?.errorMessage || error.message)
            return;
        }

    }

    const handleCancel = () => {
        navigate('/pricegroups')
    }

    useEffect(() => {
        if (pgName && description) {
            if (editdata) {
                console.log(editdata);
                if (editdata.pgId !== pgName || editdata.description !== description) {
                    setSaveDisable(false);
                } else {
                    setSaveDisable(true);
                }
            } else {
                setSaveDisable(false);
            }
        } else {
            setSaveDisable(true);
        }
    }, [pgName, description]);
    return (
        <div className='w-full overflow-scroll'>
            <FormPageHeader
                componentName="Price Group"
                handleDelete={handleDelete}
                handleSubmit={handleSubmit}
                breadCrumbSeperator=">"
                currentPage={id ? "Update Price Group" : "Add Price Group"}
                parentBreadcrumbData={[{ pageName: 'Price Group List', pageLink: '/pricegroups' }]}
                successMsg={successMsg}
                snackState={snackState}
                hideDelete={hideDelete}
                handleCancel={handleCancel}
                saveDisable={saveDisable}
                error={error}
            >

                <Tabs
                    value={tabValue}
                    textColor="inherit"
                    indicatorColor="secondary"
                    variant="scrollable"
                    scrollButtons="auto"
                    classes={{ root: 'w-full border-b-1' }}
                >
                    <Tab label="Basic Info" sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }} />
                </Tabs>
            </FormPageHeader>
            <div className="p-16 sm:p-24 max-w-3xl">
                <div className={tabValue !== 0 ? 'hidden' : ''}>
                    <label>*Name</label>
                    <TextField
                        className="mt-8 mb-16"
                        required
                        autoFocus
                        id="name"
                        variant="outlined"
                        fullWidth
                        name='pgName'
                        value={pgName}
                        error={(checksubmit && !pgName) || validError.pgName ? true : false}
                        helperText={(checksubmit && !pgName) ? "This field is required" : validError.pgName}
                        onChange={(e) => { setPgName(e.target.value.toUpperCase()) }}
                        disabled={id ? true : false}
                        inputProps={{ maxLength: 10 }}
                        sx={id ? { 
                          backgroundColor: 'action.disabledBackground',
                          "& .MuiInputBase-input.Mui-disabled": {
                            WebkitTextFillColor: (theme) => theme.palette.text.primary,
                          }
                        } : {}}
                    />
                    <label>*Description</label>
                    <TextField
                        className="mt-8 mb-16"
                        required
                        autoFocus
                        id="name"
                        variant="outlined"
                        fullWidth
                        name='description'
                        value={description}
                        error={(checksubmit && !description) || validError.description ? true : false}
                        helperText={(checksubmit && !description) ? "This field is required" : validError.description}
                        onChange={(e) => setDescription(e.target.value)}
                    />
                </div>

            </div>


        </div >
    )
}

export default PriceGroupForm